import React, { useContext, useEffect } from "react";
import GoogleLogin from "react-google-login";

import Auth from "../../../service/auth";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH;

const MODE = {
  LOGIN: 0,
  SIGNUP: 1,
  GOOGLE_STEP_2: 2,
  HOME: 3,
};

export default ({ mode, setMode, setDetails }) => {
  const signup = (profile) => {
    const { email, name, imageUrl, googleId } = profile;
    setDetails({ email, googleUserId: googleId, name, imageUrl });
  };
  const login = async (profile) => {
    const { email, googleId } = profile;
    const done = await Auth.googleLogin({ email, googleUserId: googleId });
    if (done) setMode(MODE.HOME);
  };

  const success = (res) => {
    const profile = res && res.profileObj;
    if (mode === MODE.LOGIN) login(profile);
    else if (mode === MODE.SIGNUP) signup(profile);
  };
  const failure = (err) => {
  };
  return (
    <>
      <GoogleLogin
        clientId={CLIENT_ID}
        buttonText={
          mode === MODE.LOGIN ? "Login using Google" : "Signup using Google "
        }
        onSuccess={success}
        onFailur={failure}
        cookiePolicy={"single_host_origin"}
      />
    </>
  );
};
